<template>
    <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float: left;padding-top: 10px;padding-left: 15px;text-align: left">
            <el-form :inline="true" :model="filters" :size="size">
                <el-form-item label="用户ID" prop="userId">
                    <el-input v-model="filters.userId" placeholder="请输入用户ID"></el-input>
                </el-form-item>
                <el-form-item label="年份" prop="dataYear">
                    <el-input v-model="filters.dataYear" placeholder="请输入合法年份"></el-input>
                </el-form-item>
                <el-form-item label="权限类型" prop="permType">
                    <el-select v-model="filters.permType" placeholder="请选择" clearable>
                        <el-option key="1" label="白名单" value="1"></el-option>
                        <el-option key="2" label="黑名单" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="启用状态" prop="status">
                    <el-select v-model="filters.status" placeholder="请选择" clearable>
                        <el-option key="0" label="启用" value="0"></el-option>
                        <el-option key="1" label="禁用" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作方" prop="channel" >
                    <el-select
                        remote
                        filterable
                        clearable
                        v-model="filters.partnersId"
                        placeholder="请输入合作方"
                        style="width:100%">
                        <el-option
                            v-for="item in partnersList"
                            :key="item.partnersId"
                            :label="item.partnersName"
                            :value="item.partnersId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作方渠道" prop="channel" >
                    <el-select
                        remote
                        clearable
                        @change='getChannelByName'
                        :remote-method="getParentChannelList"
                        v-model="filters.channel"
                        placeholder="请输入合作方渠道"
                        style="width:100%">
                        <el-option
                            v-for="item in parentChannelList"
                            :key="item.channel"
                            :label="item.channelName"
                            :value="item.channel">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-search" label="搜索" perms="user:perm:list" type="primary" @click="findPage({pageRequest:{current: 1,size: 10}})"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-search" label="新增" perms="user:perm:add" type="success" @click="handleAdd"/>
                </el-form-item>
            </el-form>
        </div>
        <div class="toolbar" style="float:right;padding-top:10px;padding-right:15px;">
            <!--表格显示列界面-->
        </div>
        <table-column-filter-dialog
            ref="tableColumnFilterDialog"
            :columns="columns"
            @handleFilterColumns="handleFilterColumns">
        </table-column-filter-dialog>
        <!--表格树内容栏-->
        <perm-table
            :page="page"
            :showOperation='!!adminFlag'
            permsEdit="user:perm:list"
            :columns="columns"
            :selectionChange="selectionChange"
            :handleCurrentHandle="handleCurrentHandle"
            :loading="loading"
            size="mini"
            @handleEdit="handleEdit"
            @findPage="findPage">
        </perm-table>

        <el-dialog :title="!dataForm.createTime ? '新增黑白名单' : '编辑黑白名单'"
                   width="50%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='cancel'>
            <el-form
                :model="dataForm"
                :rules="dataRule"
                ref="dataForm"
                @keyup.enter.native="submitForm(dataForm.createTime ? 2 : 1)"
                label-width="120px"
                :size="size"
                style="text-align:left;"
                v-loading="loadingData">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="用户ID" prop="userId">
                            <el-input v-model="dataForm.userId" placeholder="请输入用户ID" style='width:203px'></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="用户名称" prop="userName">
                            <el-input v-model="dataForm.userName" placeholder="请输入用户名称" style='width:203px'></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="权限类型" prop="permType">
                            <el-select v-model="dataForm.permType"
                                       placeholder="请选择权限类型"
                                       no-data-text="暂无数据">
                                <el-option
                                    v-for="item in permItemList"
                                    :key="item.key"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="年份" prop="dataYear">
                            <el-input v-model="dataForm.dataYear" placeholder="请输入数据年份" style='width:203px'></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="过期时间" prop="expireTime">
                            <el-date-picker
                                style='width:203px'
                                v-model="dataForm.expireTime"
                                type="datetime"
                                placeholder="请选择过期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="启用状态" prop="status">
                            <el-select v-model="dataForm.status" placeholder="请选择状态" style="width:215px">
                                <el-option
                                    v-for="item in statusItemList"
                                    :key="item.key"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="合作方" prop="partnersId">
                            <el-select
                                style='width:203px'
                                v-model="dataForm.partnersId"
                                placeholder="请选择合作方">
                                <el-option
                                    v-for="item in partnersList"
                                    :key="item.partnersId"
                                    :label="item.partnersName"
                                    :value="item.partnersId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="渠道" prop="channel">
                            <el-select v-model="dataForm.channel" placeholder="请选择渠道" style="width:215px">
                                <el-option
                                    v-for="item in parentChannelList"
                                    :key="item.channel"
                                    :label="item.channelName"
                                    :value="item.channel">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="备注" prop="remark">
                            <el-input
                                style='width:203px'
                                v-model="dataForm.remark"
                                placeholder="请输入备注信息">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="限制数量" prop="countLimit">
                            <el-input
                                style='width:203px'
                                v-model="dataForm.countLimit"
                                placeholder="请输入限制数量">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="分享裂变" prop="shareChannel">
                            <el-select v-model="dataForm.shareChannel" placeholder="请选择状态" style="width:215px">
                                <el-option
                                    v-for="item in shareChannelList"
                                    :key="item.key"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :size="size"  @click="cancel">取消</el-button>
                <el-button :size="size"  type="primary" :loading="editLoading" @click="submitForm(dataForm.createTime ? 2 : 1)">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import PopupTreeInput from '../../Component/PopupTreeInput/Index'
import PermButton from '../../Component/PermButton/Index'
import PermTable from '../../Component/PermTable/Index'
import TableColumnFilterDialog from '../../Component/TableColumnFilterDialog/Index'

export default {
    name: 'Userperm',
    components: {
        PermTable,
        PermButton,
        PopupTreeInput,
        TableColumnFilterDialog
    },
    data: function() {
        return {
            filters: {
                permType: '',
                userId: '',
                dataYear: '',
                status: '',
                partnersId: '',
                channel: ''
            },
            filterColumns: [],
            columns: [],
            page: {},
            pageRequest: {
                current: 1,
                size: 10
            },
            adminFlag: JSON.parse(sessionStorage.getItem('user')).admin || '',
            loading: false,
            size: 'small',
            dataForm: {
                userId: '',
                permType: '',
                expireTime: this.getDefaultTime(),
                status: '',
                dataYear: '',
                channel: '',
                channelId: '',
                channelName: '',
                userName: '',
                phone: '',
                remark: '',
                partnersId: '',
                partnersName: '',
                countLimit: '',
                shareChannel: ''
            },
            dialogVisible: false,
            loadingData: true,
            editLoading: false,
            dataRule: {
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                dataYear: [{ required: true, message: '数据年份不能为空', trigger: 'blur' }],
                expireTime: [{ required: true, message: '过期时间不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '启用状态不能为空', trigger: 'blur' }],
                permType: [{ required: true, message: '起始数不能为空', trigger: 'blur' }],
                shareChannel: [{ required: true, message: '裂变状态不能为空', trigger: 'blur' }]
            },
            statusItemList: [
                { value: 0, label: '启用', key: 0 },
                { value: 1, label: '禁用', key: 1 }
            ],
            permItemList: [
                { value: 1, label: '白名单', key: 1 },
                { value: 2, label: '黑名单', key: 2 }
            ],
            partnersList: [],
            parentChannelList: [],
            shareChannelList: [
                { value: 0, label: '不带渠道', key: 0 },
                { value: 1, label: '携带渠道', key: 1 }
            ]
        }
    },
    methods: {
        // 获取分页数据
        findPage: function(data) {
            this.loading = true
            if (data != null) {
                this.pageRequest = data.pageRequest
            }
            let param = {
                userId: this.filters.userId ? Number(this.filters.userId) : '',
                permType: this.filters.permType,
                dataYear: this.filters.dataYear ? Number(this.filters.dataYear) : '',
                partnersId: this.filters.partnersId ? Number(this.filters.partnersId) : '',
                status: this.filters.status ? Number(this.filters.status) : '',
                channel: this.filters.channel
            }
            param = Object.assign(param, this.pageRequest)
            this.$api.userperm.getUserPermList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }
                this.page = res.data
                this.loading = false
            }).then(data != null ? data.callback : '')
        },
        handleEdit(item) {
            console.log(this.dataForm)
            this.dialogVisible = true
            this.loadingData = false
            this.dataForm = this.dataForm ? item.row : {}
        },
        selectionChange(selections) {
            console.log(selections)
        },
        handleCurrentHandle: function(val) {
            console.log('handleCurrentHandle>>' + val)
        },
        // 处理表格列过滤显示
        handleFilterColumns: function(data) {
            this.filterColumns = data.filterColumns
            this.$refs.tableColumnFilterDialog.setDialogVisible(false)
        },
        formatPermStatus(q, w, row) {
            var text = '未知'
            switch (q.permType) {
                case 1:
                    text = '白名单'
                    break
                case 2:
                    text = '黑名单'
                    break
            }
            return text
        },
        formatStatus(q, w, row) {
            var text = '未知'
            switch (q.status) {
                case 0:
                    text = '启用'
                    break
                case 1:
                    text = '禁用'
                    break
            }
            return text
        },
        initColumns() {
            this.columns = [
                { prop: 'userId', label: '用户ID', minWidth: 30 },
                { prop: 'userName', label: '用户名称', minWidth: 30 },
                { prop: 'dataYear', label: '年份', minWidth: 30 },
                { prop: 'channelName', label: '渠道名称', minWidth: 30 },
                { prop: 'partnersName', label: '合作方名称', minWidth: 30 },
                { prop: 'permType', label: '权限类型', minWidth: 30, formatter: this.formatPermStatus },
                { prop: 'expireTime', label: '过期时间', minWidth: 30 },
                { prop: 'countLimit', label: '限制数量', minWidth: 30 },
                { prop: 'status', label: '状态', minWidth: 30, formatter: this.formatStatus }
            ]
            this.filterColumns = JSON.parse(JSON.stringify(this.columns))
        },
        handleAdd() {
            this.dialogVisible = true
            this.loadingData = false
            this.dataForm = {
                userId: '',
                permType: 1,
                expireTime: this.getDefaultTime(),
                status: 0,
                dataYear: this.getDefualtYear(),
                channel: '',
                channelId: '',
                channelName: '',
                userName: '',
                phone: '',
                remark: '',
                partnersId: '',
                partnersName: '',
                countLimit: 30,
                shareChannel: 1
            }
        },
        cancel() {
            this.dialogVisible = false
            this.$nextTick(() => {
                this.$refs.dataForm.resetFields()
            })
        },
        platformChange(val) {
            this.$forceUpdate()
        },
        addEdite(flag) {
            var method
            var message
            switch (flag) {
                case 1:
                    method = 'POST'
                    message = '新增成功'
                    break
                case 2:
                    method = 'PUT'
                    message = '修改成功'
                    break
            }
            this.editLoading = true
            this.dataForm.status = Number(this.dataForm.status)
            this.dataForm.shareChannel = Number(this.dataForm.shareChannel)
            for (let i = 0; i < this.partnersList.length; i++) {
                if (this.dataForm.partnersId === this.partnersList[i].partnersId) {
                    this.dataForm.partnersName = this.partnersList[i].partnersName
                    break
                }
            }
            for (let i = 0; i < this.parentChannelList.length; i++) {
                if (this.dataForm.channel === this.parentChannelList[i].channel) {
                    this.dataForm.channelName = this.parentChannelList[i].channelName
                    break
                }
            }
            this.$api.userperm.userPerm({ data: { ...this.dataForm }, method }).then(res => {
                this.editLoading = false
                if (!res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.$refs.dataForm.resetFields()
                // this.$refs.upLoadForm.clearFiles()
                this.$message({ message, type: 'success' })
                this.findPage()
                // this.destroeee()
                this.dialogVisible = false
            })
        },
        submitForm(flag) {
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.addEdite(flag)
                }
            })
        },
        parserDate(date) {
            var t = Date.parse(date)
            if (!isNaN(t)) {
                return new Date(Date.parse(date.replace(/-/g, '/')))
            }
        },
        // 获取默认时间
        getDefaultTime() {
            // debugger
            var mm = '/08'
            var dd = '/31'
            var nowsday = new Date()
            var yy = nowsday.getMonth() + 1 > 8 ? nowsday.getFullYear() + 1 : nowsday.getFullYear()
            // parserDate()
            var time = this.parserDate(new Date(yy + mm + dd).toLocaleDateString() + ' 23:59:59')
            console.log(time)
            if (this.dataForm) {
                this.dataForm.expireTime = time
            }
            return time
        },
        getDefualtYear() {
            var nowsday = new Date()
            var year = nowsday.getMonth() + 1 > 8 ? nowsday.getFullYear() + 1 : nowsday.getFullYear()
            return year
        },
        // 获取合作方
        loadInitData() {
            this.$api.partners.getAllWishPartners().then(res => {
                this.partnersList = res.data
            })
        },
        getChannelByName() {
            this.$forceUpdate()
            // for (let i = 0; i < this.parentChannelList.length; i++) {
            //     if (this.dataForm.remark === this.parentChannelList[i].channelName) {
            //         this.dataForm.remark = this.parentChannelList[i].channelName
            //         this.dataForm.parentChannel = this.parentChannelList[i].channel
            //         this.dataForm.parentId = this.parentChannelList[i].channelId
            //         break
            //     }
            // }
            // console.log(this.dataForm)
        },
        getParentChannelList(params) {
            // console.log(params)
            // const data = {
            //     channelName: params
            // }
            this.$api.role.getAllChannelData().then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.parentChannelList = res.data
                console.log(this.parentChannelList)
            })
        }
    },
    mounted() {
        this.getParentChannelList()
        this.initColumns()
        this.loadInitData()
        this.findPage(null)
        this.getDefaultTime()
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Manager/Base/Userperm.vue